export default __webpack_public_path__ + "static/media/wordpress.eedb3ed8.png";